import React from "react";

const EmptyState = ({ title, description, buttonText, buttonPath, onClick }) => {

  return (
    <div className="h-100 d-flex justify-content-center align-items-center">
      <div className="d-flex flex-column align-items-center">
        <img src="/common/NotFound.png" alt="Empty State" className="mb-24" />
        <span className="text-16 text-484747">{title}</span>
        <p className="text-14 text-A1A1A1 mb-24">{description}</p>
        {/* {buttonText  && (
          <button className="add-store" onClick={() => { buttonPath && navigate(buttonPath); onClick()}}>
            <img src="/icons/addicon.svg" alt="" className="mr-6" /> {buttonText}
          </button>
        )} */}
      </div>
    </div>
  );
};

export default EmptyState;
